import {ButtonModel} from '@mintdata/mint-components/components/button/ButtonModel';
import {FieldPath} from '@mintdata/mint-kit/api/properties/BindPath';
import {BaseFieldConverter} from '@mintdata/mint-kit/impl/properties/converters/BaseFieldConverter';

export class ButtonConverter extends BaseFieldConverter<ButtonModel>
{
    public static readonly CAPTION:FieldPath = 'caption';
    public static readonly CAPTION_VISIBILITY:FieldPath = 'captionVisibility';
    public static readonly ICON_RIGHT:FieldPath = 'iconRight';
    public static readonly ICON_LEFT:FieldPath = 'iconLeft';
    public static readonly IS_DISABLED:FieldPath = 'isDisabled';
    public static readonly TYPE:FieldPath = 'type';

    public static readonly TYPEFACE:FieldPath = 'font.typeface';
    public static readonly WEIGHT:FieldPath = 'font.weight';
    public static readonly SIZE:FieldPath = 'font.size.unitsString';
    public static readonly LINE_HEIGHT:FieldPath = 'font.lineHeight.unitsString';
    public static readonly CHARACTER:FieldPath = 'font.character.unitsString';
    public static readonly COLOR_HEX:FieldPath = 'font.color.hex';
    public static readonly COLOR_ALPHA:FieldPath = 'font.color.alpha';
    public static readonly COLOR_RGBA:FieldPath = 'font.color.rgba';
    // public static readonly FONT_STYLE:FieldPath = 'font.fontStyle';
    public static readonly DECORATION_UNDERLINE:FieldPath = 'font.decorationUnderline';
    public static readonly DECORATION_CROSSED:FieldPath = 'font.decorationCrossed';
    // public static readonly TRANSFORMATION:FieldPath = 'font.transformation';

    public static readonly URL:FieldPath = 'url';
    public static readonly IS_NEW_WINDOW:FieldPath = 'isNewWindow';

    public static readonly TEXT_ALIGN:FieldPath = 'textAlign';
    public static readonly TEXT_VERTICAL_ALIGN:FieldPath = 'textVerticalAlign';

    public static readonly BG_TYPE:FieldPath = 'background.type';
    public static readonly BG_SOLID_HEX:FieldPath = 'background.solidColor.color.hex';
    public static readonly BG_SOLID_ALPHA:FieldPath = 'background.solidColor.color.alpha';
    public static readonly BG_SOLID_RGBA:FieldPath = 'background.solidColor.color.rgba';
    public static readonly BG_SOLID_VISIBILITY:FieldPath = 'background.solidColor.visibility';

    public static readonly BG_GRAD_FROM_HEX:FieldPath = 'background.gradientFromColor.color.hex';
    public static readonly BG_GRAD_FROM_ALPHA:FieldPath = 'background.gradientFromColor.color.alpha';
    public static readonly BG_GRAD_FROM_RGBA:FieldPath = 'background.gradientFromColor.color.rgba';
    public static readonly BG_GRAD_FROM_VISIBILITY:FieldPath = 'background.gradientFromColor.visibility';
    public static readonly BG_GRAD_TO_HEX:FieldPath = 'background.gradientToColor.color.hex';
    public static readonly BG_GRAD_TO_ALPHA:FieldPath = 'background.gradientToColor.color.alpha';
    public static readonly BG_GRAD_TO_RGBA:FieldPath = 'background.gradientToColor.color.rgba';
    public static readonly BG_GRAD_TO_VISIBILITY:FieldPath = 'background.gradientToColor.visibility';
    public static readonly BG_GRAD_ANGLE:FieldPath = 'background.gradientAngle';

    public static readonly BORDER_COLOR_HEX:FieldPath = 'border.borderColor.color.hex';
    public static readonly BORDER_COLOR_ALPHA:FieldPath = 'border.borderColor.color.alpha';
    public static readonly BORDER_COLOR_RGBA:FieldPath = 'border.borderColor.color.rgba';
    public static readonly BORDER_COLOR_VISIBILITY:FieldPath = 'border.borderColor.visibility';
    public static readonly BORDER_THICKNESS:FieldPath = 'border.borderThickness.unitsString';
    public static readonly BORDER_STYLE:FieldPath = 'border.borderStyle';
    public static readonly BORDER_FILL:FieldPath = 'border.borderFill';
    public static readonly BORDER_RADIUS:FieldPath = 'border.borderRadius.value';
    public static readonly BORDER_RADIUS_TOP_LEFT:FieldPath = 'border.borderRadius.topLeft';
    public static readonly BORDER_RADIUS_TOP_RIGHT:FieldPath = 'border.borderRadius.topRight';
    public static readonly BORDER_RADIUS_BOTTOM_RIGHT:FieldPath = 'border.borderRadius.bottomRight';
    public static readonly BORDER_RADIUS_BOTTOM_LEFT:FieldPath = 'border.borderRadius.bottomLeft';

    public static readonly BOXSHADOW_COLOR_HEX:FieldPath = 'boxShadow.color.color.hex';
    public static readonly BOXSHADOW_COLOR_ALPHA:FieldPath = 'boxShadow.color.color.alpha';
    public static readonly BOXSHADOW_COLOR_RGBA:FieldPath = 'boxShadow.color.color.rgba';
    public static readonly BOXSHADOW_COLOR_VISIBILITY:FieldPath = 'boxShadow.color.visibility';
    public static readonly BOXSHADOW_DELTAX:FieldPath = 'boxShadow.deltaX.unitsString';
    public static readonly BOXSHADOW_DELTAY:FieldPath = 'boxShadow.deltaY.unitsString';
    public static readonly BOXSHADOW_BLUR:FieldPath = 'boxShadow.blur.unitsString';
    public static readonly BOXSHADOW_SPREAD:FieldPath = 'boxShadow.spread.unitsString';

    public static readonly PADDING:FieldPath = 'padding.value';
    public static readonly PADDING_LEFT:FieldPath = 'padding.left';
    public static readonly PADDING_TOP:FieldPath = 'padding.top';
    public static readonly PADDING_RIGHT:FieldPath = 'padding.right';
    public static readonly PADDING_BOTTOM:FieldPath = 'padding.bottom';
}
